<app-header class="view-header"></app-header>

<div class="wrapper">

    <div class="banner-img-name view-top">

        <div class="main" style="padding-bottom: 0;">

            <h2>Preview Application Details</h2>

        </div>

    </div>

    <section class="main">

        <form action="" method="post" name="applicationViewForm" autocomplete="off">

            <input type="hidden" name="loggedUserId" value="" />

            <div class="profile-view">

                <div class="h_logo">
                    <img src="assets/images/logo-nis.png" style="width:140px;">
                </div>

                <div class="s-head">

                    <div class="result-header">

                        <div class="post-img">
                            <img [src]="bioDetails.passportImageData">
                        </div>
                        <div class="user-info-detail">
                            <div class="upper_bar" style="border-bottom:1px solid #979797;">

                                <div class="barcode">
                                    <div class="" *ngIf="bioDetails.paymentStatus === constants.STATUS_SUCCESS">
                                        <ngx-barcode [bc-value]="barCodeValue" [bc-display-value]="true" [bc-width]="1"
                                            [bc-height]="40" [bc-font-size]="14"></ngx-barcode>
                                    </div>
                                </div>

                                <div class="visa_type" style="text-align: right;">

                                    <p>e-Visa Application</p>

                                    <span style="color:#aaa;">{{generalDetails.visaClass}}</span>

                                </div>

                            </div>
                            <div class="common_view">

                                <div>
                                    <label>Full Name</label>
                                    <p class="p-body">{{bioDetails.fullName}}</p>
                                </div>

                                <ng-container *ngIf="bioDetails.applicationStatus === constants.STATUS_SUCCESS">
                                    <div>
                                        <label>Application No.</label>
                                        <p class="p-body">{{bioDetails.applicationId}}</p>
                                    </div>

                                    <div>
                                        <label>Reference No.</label>
                                        <p class="p-body">{{bioDetails.referenceId}}</p>
                                    </div>
                                </ng-container>

                                <div>
                                    <label>Application Date</label>
                                    <p class="p-body">{{bioDetails.applicationDate}}</p>
                                </div>

                                <div *ngIf="bioDetails.applicationStatus === constants.STATUS_SUCCESS">
                                    <label>Application Expiry Date</label>
                                    <p class="p-body">{{bioDetails.applicationExpiryDate}}</p>
                                </div>

                                <div>
                                    <label>Status</label>
                                    <p class="p-body"><img [src]="bioDetails.paymentStatusIcon" class="status_img"
                                            style="width: 100%; max-width: 51px;"></p>
                                </div>

                            </div>

                        </div>



                    </div>


                </div>

                <section id="applicationdetail">

                    <div class="s-content">

                        <div class="border_line" style="border: 1px solid #979797;">
                            <p class="p-body  line pb10">Applicant Details</p>
                            <div class="sr-p-info">
                                <div>
                                    <label>Full name</label>
                                    <p>{{bioDetails.fullName}}</p>
                                </div>

                                <div>
                                    <label>E-mail Address</label>
                                    <p>{{bioDetails.email}}</p>
                                </div>

                                <div>
                                    <label>Gender</label>
                                    <p>{{bioDetails.genderLabel}}</p>
                                </div>

                                <div>
                                    <label>Marital Status</label>
                                    <p>{{bioDetails.maritalStatusLabel}}</p>
                                </div>

                                <div>
                                    <label>Date of Birth</label>
                                    <p>{{bioDetails.dateOfBirth}}</p>
                                </div>

                                <div>
                                    <label>Place of Birth</label>
                                    <p>{{bioDetails.placeOfBirth}}</p>
                                </div>

                                <div>
                                    <label>Passport Number</label>
                                    <p>{{bioDetails.passportNumber}}</p>
                                </div>

                                <div>
                                    <label>Passport Expiry Date</label>
                                    <p>{{bioDetails.passportExpiryDate}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="border_line" style="border: 1px solid #979797;">
                            <p class="p-body  line">Visa Details</p>
                            <div class="sr-p-info">
                                <div>
                                    <label>Nationality</label>
                                    <p>{{generalDetails.nationalityLabel}}</p>
                                </div>

                                <div style="border-bottom: 1px solid #aeaeae !important;">
                                    <label>Passport Type</label>


                                    <p>{{getPassportType || generalDetails.passportTypeLabel}}</p>
                                    <!-- <p>{{generalDetails.passportTypeLabel}}</p> -->
                                </div>

                                <div>
                                    <label>Visa Class</label>
                                    <p>{{generalDetails.visaClass}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="border_line" style="border: 1px solid #979797;">
                            <p class="p-body  line pb10">Travel Details</p>
                            <div class="sr-p-info">
                                <div>
                                    <label>Purpose of Journey</label>
                                    <p>{{travelDetails.journeyPurpose}}</p>
                                </div>

                                <div>
                                    <label>Airline</label>
                                    <p>{{travelDetails.airlineName}}</p>
                                </div>

                                <div>
                                    <label>Flight Number</label>
                                    <p>{{travelDetails.flightNumber}}</p>
                                </div>

                                <div>
                                    <label>Country of Departure</label>
                                    <p>{{travelDetails.departureCountryLabel}}</p>
                                </div>

                                <div>
                                    <label>Date of departure(dd/mm/yyyy)</label>
                                    <p>{{travelDetails.expectedDepartureDate}}</p>
                                </div>

                                <div>
                                    <label>Date of arrival(dd/mm/yyyy)</label>
                                    <p>{{travelDetails.expectedArrivalDate}}</p>
                                </div>

                                <div>
                                    <label>Port of Entry</label>
                                    <p>{{travelDetails.entryPortLabel}}</p>
                                </div>

                                <div>
                                    <label>Duration of Stay</label>
                                    <p>{{travelDetails.durationOfStay}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="border_line" style="border: 1px solid #979797;">
                            <p class="p-body  line pb10">Contact Details</p>
                            <div class="sr-p-info">
                                <div>
                                    <label>Contact Name/ Hotel Name</label>
                                    <p>{{contactDetails.contactName}}</p>
                                </div>

                                <div>
                                    <label>Contact Number</label>
                                    <p>{{contactDetails.dialCode}} {{contactDetails.contactPhone}}</p>
                                </div>

                                <div>
                                    <label>Contact E-mail</label>
                                    <p>{{contactDetails.contactEmail}}</p>
                                </div>

                                <div>
                                    <label>Contact Address </label>
                                    <p>{{contactDetails.contactAddress}}, {{contactDetails.contactCity}},
                                        {{contactDetails.contactStateLabel}}, {{contactDetails.contactPostalCode}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="border_line" style="border: 1px solid #979797;" *ngIf="dependents?.length > 0">
                            <p class="p-body line pb10">Dependent Details</p>

                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Full Name</th>
                                            <th>Date of Birth</th>
                                            <th>Gender</th>
                                            <th>Passport Number</th>
                                            <th>Reference</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let dependent of dependents; let i = index">
                                            <td>{{dependent.fullName || dependent.firstName + ' ' + dependent.lastName}}
                                            </td>
                                            <td>{{dependent.dateOfBirth || dependent.formattedBirthDate}}</td>
                                            <td>{{dependent.genderLabel || dependent.gender}}</td>
                                            <td>{{dependent.passportNumber}}</td>
                                            <td>{{dependent.referenceId || 'N/A'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>



                        <div class="grid_two">

                            <div class="border_line">

                                <p class="p-body  line pb10">Supporting Documents</p>

                                <div class="tab50">

                                    <div *ngFor="let applicationDocument of applicationDocumentsArray;">

                                        <label>{{applicationDocument.label}}</label>

                                        <span class="fr hide"><i
                                                (click)="openFileViewModal(applicationDocument.fileBase64Data, applicationDocument.fileType)"
                                                class="fa fa-eye" style="color: green; font-size: 15px;"></i></span>

                                    </div>

                                </div>

                            </div>

                            <ng-container *ngIf="isShowPaymentDetails === true">

                                <div class="border_line pay_details">

                                    <p class="p-body  line pb10">Fee Details</p>

                                    <div class="tab50">

                                        <div *ngIf="feeDetails.isGratis === constants.TRUE" class="green_band_gratis">
                                            <span style="font-size:13px;">In view of the existing bilateral
                                                agreements/arrangements, your VISA is on gratis basis and no fee will be
                                                charged.</span>
                                        </div>

                                        <div>
                                            <label>Visa Fee</label>
                                            <span class="fr">{{feeDetails.currencySymbol}} {{feeDetails.visaFee | number
                                                : '1.2' : 'en-US'}}</span>
                                        </div>

                                        <div *ngIf="feeDetails.addOnCharges > 0">
                                            <label>eVAC Fee</label>
                                            <span class="fr">{{feeDetails.currencySymbol}} {{feeDetails.addOnCharges |
                                                number : '1.2' : 'en-US'}}</span>
                                        </div>


                                        <div *ngIf="dependantsTotalCharges">
                                            <label>Dependents Total Charges</label>
                                            <span class="fr">
                                                {{ feeDetails?.currencySymbol || '' }} {{ dependantsTotalCharges |
                                                number: '1.2-2' : 'en-US' }}
                                            </span>
                                        </div>

                                        <div *ngIf="feeDetails.totalCharges > 0">
                                            <label> Total </label>
                                            <span class="fr">
                                                {{ feeDetails?.currencySymbol || '' }} {{ feeDetails?.totalCharges |
                                                number: '1.2-2' : 'en-US' }}
                                            </span>
                                        </div>


                                        <ng-container
                                            *ngIf="bioDetails.paymentStatus === constants.STATUS_SUCCESS && isPaid === true">
                                            <div *ngIf="paymentDetails.gatewayTxnFee > 0">
                                                <label>Transaction Fee</label>
                                                <span
                                                    class="fr">{{feeDetails.currencySymbol}}{{paymentDetails.gatewayTxnFee
                                                    | number : '1.2' : 'en-US'}}</span>
                                            </div>

                                            <div class="total_box" style="border-bottom: 0px;">
                                                <label>Total Fee</label>
                                                <span
                                                    class="fr">{{feeDetails.currencySymbol}}{{paymentDetails.totalAmountCollectedByGatway
                                                    | number : '1.2' : 'en-US'}}</span>
                                            </div>
                                        </ng-container>

                                    </div>

                                </div>

                                <div *ngIf="isPaid === true && feeDetails.visaFee > constants.FALSE"
                                    class="border_line pay_details">

                                    <p class="p-body line pb10">Payment Details</p>

                                    <div class="tab50">
                                        <div>
                                            <label>Payment Date</label>
                                            <span class="fr">{{paymentDetails.paymentDate}}</span>
                                        </div>

                                        <div style="border-bottom: 1px solid #aeaeae !important;">
                                            <label>Payment Gateway</label>
                                            <span class="fr">{{paymentDetails.paymentGateway}}</span>
                                        </div>

                                        <div>
                                            <label>Validation Number</label>
                                            <span class="fr">{{paymentDetails.validationNo}}</span>
                                        </div>

                                    </div>

                                </div>

                            </ng-container>

                        </div>

                    </div>

                </section>

                <div class="view-buttons">

                    <input type="button" (click)="backToPage()" value="Close" class="back_btn">

                    <input *ngIf="bioDetails.applicationStatus === constants.STATUS_INITIATE" type="button"
                        (click)="editApplication()" value="Edit" class="edit_btn" [disabled]="isDisabledButton">

                    <ng-container
                        *ngIf="bioDetails.applicationStatus === constants.STATUS_INITIATE && hasApplicationZeroFee === false">

                        <input type="button" (click)="openConfirmation(constants.TRUE);" value="Submit & Pay Now"
                            class="custom_btn" [disabled]="isDisabledButton">

                        <input type="button" (click)="openConfirmation(constants.FALSE);" value="Submit & Pay Later"
                            class="save_btn" [disabled]="isDisabledButton">

                    </ng-container>

                    <ng-container
                        *ngIf="bioDetails.applicationStatus === constants.STATUS_INITIATE && hasApplicationZeroFee === true">

                        <input type="button" (click)="openConfirmation(constants.FALSE);" value="Confirm & Submit"
                            class="save_btn" [disabled]="isDisabledButton">

                    </ng-container>

                    <input *ngIf="bioDetails.applicationStatus === constants.STATUS_SUCCESS" type="button"
                        (click)="printApplication()" value="Print Application" class="save_btn">

                    <input *ngIf="bioDetails.paymentStatus === constants.STATUS_SUCCESS" type="button"
                        (click)="printReceipt()" value="Print Receipt" class="custom_btn pay_btn">

                    <input *ngIf="bioDetails.paymentStatus === constants.STATUS_SUCCESS" type="button"
                        (click)="storeFeeAndPaymentDataFromIOS();"
                        [value]="isShowPaymentDetails === true ? 'Hide Payment Details' : 'Show Payment Details'"
                        class="custom_btn">

                </div>

            </div>

        </form>

    </section>

</div>

<app-footer class="view-footer"></app-footer>